import { cn } from '@/lib/utils'
import { CardEvent, Container, Section, SectionHeader } from '@/ui/components'
import { memo } from 'react'
import { SectionUpcomingEventsProps } from './type'

const SectionUpcomingEvents = ({
  section,
  overline,
  titleLayout,
  title,
  buttons,
  items,
  className
}: SectionUpcomingEventsProps) => {
  const convertedButtons = buttons?.map((button) => ({
    ...button,
    size: 'm',
    mode: (button.variant == 'tertiary' ? 'invert' : 'default') as
      | 'default'
      | 'invert'
  }))

  return (
    <Section
      data={section}
      className={cn(
        's-section-upcoming-events bg-accent-300 text-neutral-100',
        className
      )}
    >
      <SectionHeader
        title={title}
        titleLayout={titleLayout}
        overline={overline}
        buttons={convertedButtons}
        mode="invert"
      />
      <Container anim="fade-in">
        <div className="pt-lg gap-xs grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {items?.map((item, index) => (
            <CardEvent key={index?.toString()} {...item} />
          ))}
        </div>
      </Container>
    </Section>
  )
}

SectionUpcomingEvents.displayName = 'SectionUpcomingEvents'

export default memo(SectionUpcomingEvents)
